import BpkStarRating from '@skyscanner/backpack-web/bpk-component-star-rating';

import { withI18n } from '../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';

import { getId, getAriaHidden } from '@shared/utils-frontend/a11y';

type Props = {
  i18n: I18nService;
  stars?: Maybe<number>;
  className?: Maybe<string>;
  index?: number;
  large?: boolean;
};

const starsLabel = (i18n: I18nService) => (stars: number) =>
  i18n.translatePlural('HotelInfo_number_stars', stars, 'number');

const HotelStars = ({ i18n, index, stars = 0, ...rest }: Props) =>
  stars && stars > 0 ? (
    <BpkStarRating
      rating={stars}
      maxRating={stars}
      id={getId('hotel_star', index)}
      ratingLabel={starsLabel(i18n)}
      aria-hidden={getAriaHidden(index)}
      {...rest}
    />
  ) : null;

export default withI18n(HotelStars);
